var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EndpageTemplate',{attrs:{"model":_vm.model,"breadcrumb-items":_vm.breadcrumbItems,"recommended-articles":_vm.recommendedArticles}})
}
var staticRenderFns = []

export { render, staticRenderFns }